import * as React from "react";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { translate } from "react-i18next";
import { XCircle } from "react-feather";
import { InjectedTranslateProps } from "react-i18next/src/props";
import { FieldProps } from "formik";
import { renderFieldsHelper } from "../FormikUtils";
import { CurrentProductVersionItem } from "../../Modules/ProductsNew/Types/CurrentProductVersionType";

type SelectProductProps = InjectedTranslateProps &
  FieldProps & {
    fetchData: (query: string) => void;
    onShowMoreResults: (page: number) => void;
    onProductChange: (product: CurrentProductVersionItem) => void;
    products: Array<CurrentProductVersionItem>;
    label: string;
    error: string;
    placeholder: string;
    isLoading: boolean;
    disabled?: boolean;
    required?: boolean;
    under?: {
      containerClassName: string;
      fieldClassName: string;
    };
  };

const SelectProduct: React.FunctionComponent<SelectProductProps> = (
  props: SelectProductProps,
): React.ReactElement => {
  const PER_PAGE = 10;

  const {
    t,
    fetchData,
    under,
    label,
    placeholder,
    products,
    isLoading,
    disabled,
    onShowMoreResults,
    form,
    field,
    field: { value },
    onProductChange,
    required,
  } = props;
  const { displayError, error } = renderFieldsHelper(props);

  const renderMenuItemChildren = item => {
    const { name, version, status } = item;

    return (
      <div>
        <span>{name}</span>
        <span className="font-small">{` ${t("Version")}: ${version} - ${
          status.name
        }`}</span>
      </div>
    );
  };

  return (
    <div
      id="product-select-container"
      className={`form-group selectWithPagination ${
        displayError ? "has-error" : ""
      } ${under ? under.containerClassName : "row"} ${
        required ? "required" : ""
      }`}
    >
      <div className={`row`}>
        {label && (
          <div
            className={`${under ? under.fieldClassName : "col-sm-4 col-md-3"} ${
              !label || label.length === 0 ? "hidden" : ""
            }`}
          >
            <label htmlFor="">{label}</label>
          </div>
        )}
        <div className={under ? under.fieldClassName : "col-sm-8 col-md-9"}>
          <div className="form__clear">
            <AsyncTypeahead
              id="product-version-select"
              isLoading={isLoading}
              disabled={disabled}
              options={products}
              selected={!value ? [] : !Array.isArray(value) ? [value] : value}
              multiple={false}
              maxResults={PER_PAGE}
              labelKey="name"
              minLength={0}
              onSearch={fetchData}
              placeholder={placeholder}
              onChange={onProductChange}
              paginate={true}
              promptText={t("Type to search...")}
              searchText={t("Searching...")}
              paginationText={t("Show more products")}
              emptyLabel={t("Products not found")}
              renderMenuItemChildren={renderMenuItemChildren}
              useCache={false}
              onPaginate={(_, showResults) => onShowMoreResults(showResults)}
            />
            <span aria-hidden="true" className="rw-i rw-i-caret-down" />

            <div
              id="product-version-clear"
              className="form__clear-button"
              onClick={() => form.setFieldValue(field.name, [])}
            >
              <XCircle size={15} />
            </div>
          </div>
          {displayError && <span className="help-block">{t(error)}</span>}
        </div>
      </div>
    </div>
  );
};

export default translate()(SelectProduct);
